export default "<section style=\"height: auto; margin-top: 25%; padding-bottom: 45%;\">\n    <app-oshop-template-two></app-oshop-template-two>\n</section>"